module.exports = __webpack_public_path__ + "static/water_bg_mobile-dea4811c55be0ee2602585cb80812212.svg";